import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class KMFComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
